import { module } from 'angular';
import templateBuilderKpathDisplay from './builder/display.html';
import templateBuilderKpathValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/kpath/display.html', templateBuilderKpathDisplay);
	$templateCache.put('kform/components/kpath/validate.html', templateBuilderKpathValidate);
});
